<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="col-md-12">
              <div class="row">
                <div class="col-lg-2 col-sm-6 mt-sm-0 mt-4">
                  <div class="card h-100 bg-gradient-primary shadow-lg">
                    <div
                      class="card-body d-flex flex-column justify-content-center text-center"
                    >
                      <router-link :to="{ name: 'contrato-general' }">
                        <i
                          class="ri-file-add-line text-white mb-3"
                          aria-hidden="true"
                        ></i>
                        <h5 class="text-white text-sm">General</h5>
                      </router-link>
                    </div>
                  </div>
                </div>
                <div class="col-lg-2 col-sm-6 mt-sm-0 mt-4">
                  <div class="card h-100 bg-gradient-primary shadow-lg">
                    <div
                      class="card-body d-flex flex-column justify-content-center text-center"
                    >
                      <router-link :to="{ name: 'contrato-domiciliacion' }">
                        <i
                          class="ri-file-add-line text-white mb-3"
                          aria-hidden="true"
                        ></i>
                        <h5 class="text-white text-sm">Domiciliación</h5>
                      </router-link>
                    </div>
                  </div>
                </div>
                <div class="col-lg-2 col-sm-6 mt-sm-0 mt-4">
                  <div class="card h-100 bg-gradient-primary shadow-lg">
                    <div
                      class="card-body d-flex flex-column justify-content-center text-center"
                    >
                      <router-link :to="{ name: 'contrato-compra-venta' }">
                        <i
                          class="ri-file-add-line text-white mb-3"
                          aria-hidden="true"
                        ></i>
                        <h5 class="text-white text-sm">Compra-Venta</h5>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Contratos",
};
</script>

<style></style>
